import React from 'react';
function VisaLogo() {
  return <svg viewBox="0 0 48 16" className="h-4 w-auto" aria-label="Visa" data-id="element-255">
      <text x="2" y="13" fill="#1A1F71" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="15" data-id="element-256">
        VISA
      </text>
    </svg>;
}
function MastercardLogo() {
  return <svg viewBox="0 0 38 24" className="h-4 w-auto" aria-label="Mastercard" data-id="element-257">
      <circle cx="13" cy="12" r="9" fill="#EB001B" data-id="element-258" />
      <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-259" />
      <path d="M19 5.3a9 9 0 0 1 0 13.4 9 9 0 0 1 0-13.4z" fill="#FF5F00" data-id="element-260" />
    </svg>;
}
function AmexLogo() {
  return <svg viewBox="0 0 40 16" className="h-4 w-auto" aria-label="American Express" data-id="element-261">
      <rect width="40" height="16" rx="2" fill="#006FCF" data-id="element-262" />
      <text x="20" y="11.5" fill="#fff" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="7" textAnchor="middle" data-id="element-263">
        AMEX
      </text>
    </svg>;
}
function PayPalLogo() {
  return <svg viewBox="0 0 44 16" className="h-4 w-auto" aria-label="PayPal" data-id="element-264">
      <text x="2" y="12.5" fill="#003087" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="11" data-id="element-265">
        Pay
      </text>
      <text x="22" y="12.5" fill="#009CDE" fontFamily="Arial, sans-serif" fontWeight="bold" fontStyle="italic" fontSize="11" data-id="element-266">
        Pal
      </text>
    </svg>;
}
function ApplePayLogo() {
  return <svg viewBox="0 0 44 16" className="h-4 w-auto" aria-label="Apple Pay" data-id="element-267">
      <path d="M8.2 3.8c-.5.6-1.3 1-2 1-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.5-.7 2.1zm.7 1.1c-1.1-.1-2.1.6-2.6.6s-1.4-.6-2.3-.6C2.5 4.9 1 6.2 1 8.7c0 1.6.6 3.2 1.4 4.3.7 1 1.3 1.8 2.2 1.8s1.2-.6 2.3-.6 1.4.6 2.3.6 1.4-.8 2-1.7c.4-.5.7-1.1.9-1.7-1.2-.5-2-1.6-2-2.9 0-1.2.6-2.2 1.6-2.8-.6-.8-1.5-1.3-2.5-1.4l-.3.1z" fill="#000" data-id="element-268" />
      <text x="16" y="12" fill="#000" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="9" data-id="element-269">
        Pay
      </text>
    </svg>;
}
function GPayLogo() {
  return <svg viewBox="0 0 38 16" className="h-4 w-auto" aria-label="Google Pay" data-id="element-270">
      <text x="1" y="12.5" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="11" data-id="element-271">
        <tspan fill="#4285F4" data-id="element-272">G</tspan>
      </text>
      <text x="11" y="12.5" fill="#5F6368" fontFamily="Arial, sans-serif" fontWeight="500" fontSize="9.5" data-id="element-273">
        Pay
      </text>
    </svg>;
}
function PaymentCard({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="h-7 px-2 bg-white/95 rounded flex items-center justify-center select-none" style={{
    border: '1px solid rgba(255,255,255,0.15)'
  }} data-id="element-274">
      {children}
    </div>;
}
export function TrustBadges() {
  return <div className="flex flex-col items-center gap-2.5 mt-4" data-id="element-275">
      {/* Payment Icons Row — Shopify checkout style */}
      <div className="flex items-center justify-center gap-1.5" data-id="element-276">
        <PaymentCard data-id="element-277">
          <VisaLogo data-id="element-278" />
        </PaymentCard>
        <PaymentCard data-id="element-279">
          <MastercardLogo data-id="element-280" />
        </PaymentCard>
        <PaymentCard data-id="element-281">
          <AmexLogo data-id="element-282" />
        </PaymentCard>
        <PaymentCard data-id="element-283">
          <PayPalLogo data-id="element-284" />
        </PaymentCard>
        <PaymentCard data-id="element-285">
          <ApplePayLogo data-id="element-286" />
        </PaymentCard>
        <PaymentCard data-id="element-287">
          <GPayLogo data-id="element-288" />
        </PaymentCard>
      </div>

      {/* SSL Security — thin outline lock, minimal text */}
      <div className="flex items-center gap-1.5 text-[#6a6a5a] text-[10px] tracking-wide font-['Lato']" data-id="element-289">
        <svg viewBox="0 0 16 16" className="w-3 h-3" fill="none" stroke="#5a9a5a" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-290">
          <rect x="3" y="7" width="10" height="7" rx="1.5" data-id="element-291" />
          <path d="M5 7V5a3 3 0 0 1 6 0v2" data-id="element-292" />
        </svg>
        <span data-id="element-293">Encriptación SSL 256 bits · Seguridad de Grado Bancario</span>
      </div>

      {/* Delivery */}
      <p className="text-[#7a7a6a] text-[10px] font-['Lato'] tracking-wide" data-id="element-294">
        🚀 Entrega automática al email tras completar el pago
      </p>
    </div>;
}